import { AuthGuard } from './../../shared/guards/authGuard/auth.guard';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { GenerarReporteComponent } from './generar-reporte.component';

const routes: Routes = [
  { path: '', component: GenerarReporteComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class GenerarReporteRouting { }
